export default __webpack_public_path__ + "static/media/DENTALREFERRAL.e645e7ac.png";